import { mdiChevronRight, mdiFolderHome } from '@mdi/js';
import Icon from '@mdi/react';
import { Breadcrumbs, Stack, SxProps } from '@mui/material';
import MD5 from 'crypto-js/md5';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { IAppReduxStore } from '../../../redux/store';
import { headingFontBold, vars } from '../../../Theme';
import TranslatedCategoryName from '../../General/TranslatedCategoryName/TranslatedCategoryName';

/** Breadcrumb styles. */
export const breadcrumbsSx: SxProps = {
    flexWrap: 'nowrap',
    color: vars.black,
    pl: 1.5,
    my: 1,

    '& ol': {
        flexWrap: 'nowrap',
    },

    '& .MuiBreadcrumbs-li': {
        ...headingFontBold,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        fontSize: 14,
    },
};

/**
 * Component that shows the user's location within a project database.
 */
export default () => {
    /** Get relevant values from Redux store. */
    const structure = useSelector((store: IAppReduxStore) => store.projectViewData.structure.data);

    /** Allow component to change the URL. */
    const navigate = useNavigate();

    /** Get the replicaId, areaName, viewName and category from the react router. */
    const { replicaId, areaName, viewName, category } = useParams();

    /** Determine if one of the categories in the view has the same id as the value in the URL. */
    const match = structure?.filter(x => x.id === category)[0];

    /** Base URL for the given view. */
    const baseUrl = `/project/${replicaId}/${areaName}/${viewName}`;

    /**
     * Creates a clickable element for the breadcrumbs.
     * @param content -> Breadcrumb content.
     * @param path -> (OPTIONAL) Additional navigation path info.
     */
    const createItem = (content: JSX.Element | string, path?: string) => (
        <Stack key={path} onClick={() => navigate([baseUrl, path].filter(Boolean).join('/'))}>
            {typeof content === 'string' ? (
                <TranslatedCategoryName categoryName={content} />
            ) : (
                content
            )}
        </Stack>
    );

    return (
        <Breadcrumbs separator={<Icon path={mdiChevronRight} size={0.75} />} sx={breadcrumbsSx}>
            {createItem(<Icon path={mdiFolderHome} size={1} />)}

            {match?.category
                .split('\\')
                .map((x, i, arr) => createItem(x, MD5(arr.slice(0, i + 1).join('\\'))))}
        </Breadcrumbs>
    );
};
